module.exports = __webpack_public_path__ + "static/media/eduSample.ce9d5268.xls";